import { createReducer } from '@reduxjs/toolkit';

import insertAt from '../../utils/insert-at';
import {
  addQuoteLine,
  changeQuote,
  duplicateQuoteLine,
  removeQuoteLine,
  submit,
} from '../actions';

export default createReducer(
  {},
  /* eslint-disable no-param-reassign */
  {
    [changeQuote]: (state, { payload: { name, value } }) => {
      state[name] = value;
    },
    [addQuoteLine]: (state, { payload }) => {
      state.quoteLines = insertAt(
        state.quoteLines,
        payload.lineNumber,
        payload.id,
      );
    },
    [removeQuoteLine]: (state, { meta }) => {
      state.quoteLines = state.quoteLines.filter(
        quoteLineId => quoteLineId !== meta.quoteLineId,
      );
    },
    [duplicateQuoteLine]: (state, { payload, meta }) => {
      const index = state.quoteLines.indexOf(meta.quoteLineId);
      const newId = payload.id;

      state.quoteLines = insertAt(state.quoteLines, index + 1, newId);
    },

    [`${submit}-success`]: (state, { payload }) => payload.quote,
  },
  /* eslint-enable no-param-reassign */
);
